import { render, staticRenderFns } from "./configComponent.vue?vue&type=template&id=5670e28e&scoped=true"
import script from "./configComponent.vue?vue&type=script&lang=js"
export * from "./configComponent.vue?vue&type=script&lang=js"
import style0 from "./configComponent.vue?vue&type=style&index=0&id=5670e28e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5670e28e",
  null
  
)

export default component.exports